"use client";

import React from "react";
import { ButtonPrimary } from "@/components/common/StandardButton";
// Badge not used here
import StandardCard from "../common/StandardCard";

interface SupportCardProps {
  orderId: string;
}

const SupportCard: React.FC<SupportCardProps> = ({ orderId }) => {
  return (
    <StandardCard
      title="Support"
      headerAction={<ButtonPrimary size="sm">+ Create</ButtonPrimary>}
    >
      <div className="text-center py-8">
        <div className="text-sm text-muted-foreground mb-2">
          No support tickets
        </div>
        <div className="text-xs text-muted-foreground">
          Create a support ticket for order #{orderId.slice(-6)}
        </div>
      </div>
    </StandardCard>
  );
};

export default SupportCard;
